module.exports = __webpack_public_path__ + "img/xmark.dd1d2d36.svg";